<template>
  <div class="choices">
    <div class="editable" v-for="r in editables" @click="redo(r)">
      <Quick :r="r" />
      <button type="button" class="editable-btn"><icon name="pencil" /></button>
    </div>
  </div>
</template>

<script>
import Quick from './Quick.vue'

import { chat } from '../chat.js'

export default {
  components: {
    Quick
  },
  props: {
    show: null
  },
  computed: {
    editables() {
      const out = []
      const { __, state } = this.$root
      if (state.occasion) {
        out.push(state.occasion)
      }
      if (state.gender) {
        out.push(state.gender)
      }
      if (state.name) {
        out.push({
          model: 'name',
          title: state.name
        })
      }
      if (state.age > -1) {
        out.push({
          model: 'age',
          title: __('age textual').replace('#', state.age)
        })
      } else if (state.age === -1) {
        out.push({
          model: 'age',
          title: __('all ages')
        })
      }
      if (state.budget) {
        let title = ''
        if (typeof state.budget === 'string' && state.budget.indexOf('-') > 0){
          state.budget = state.budget.split('-')
        }
        if (state.budget[0] > 0) {
          title += __('budget min text').replace('#', state.budget[0]) + ' '
        }
        if (state.budget[1] < 105) {
          title += __('budget max text').replace('#', state.budget[1])
        }
        if (!title) {
          title = __('any budget')
        }
        out.push({
          model: 'budget',
          title
        })
      }
      if (state.categories) {
        if (state.categories.length > 1) {
          out.push({
            model: 'categories',
            title: __('# categories').replace('#', state.categories.length)
          })
        } else if (state.categories.length === 1) {
          const translated =
            window.sharedCategories &&
            window.sharedCategories.find(c => c.key === state.categories[0])
          const title =
            (translated && translated[state.lang]) || state.categories[0]
          out.push({
            model: 'categories',
            title
          })
        } else {
          out.push({
            model: 'categories',
            title: __('all categories')
          })
        }
      }
      return out
    }
  },
  methods: {
    redo(r) {
      this.$emit('update:show', 0)
      chat.send({
        data: r.data,
        next: r.model || r.fallback
      })
    }
  }
}
</script>

<style>
.choices .fill-fg {
  fill: white;
}

.choices .editables {
  flex-shrink: 0;
}
.choices .editables-h2 {
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 18px;
  letter-spacing: 0.666667px;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 2px;
}

.choices .editable {
  margin-left: -0.5em;
}
.choices .editable-btn {
  margin: 0;
  border: none;
  padding: 0;
  max-width: 1em;
  overflow: hidden;
  font-size: 18px;
  background: none;
  opacity: 1;
  vertical-align: middle;
  -webkit-appearance: none;
  appearance: none;
}
</style>
